import React, { useState } from "react"
import { Field, formValueSelector } from "redux-form"
import { FORM_NAMES } from "constants/index"
import { Card, CardBody, Row, Col, CardHeader } from "reactstrap"
import { connect } from "react-redux"
import { addBooking } from "store/actions"
import { CheckboxGroup } from "components/RenderInput"
import { SaveButton } from "components/Buttons"
import Preview from "./preview"
import ModalComponent from "components/Modals"
import Payouts from "containers/Payouts"
import { LoadingIndicator } from "components/LoadingIndicator"

let BookingsSetup = ({
  feature,
  selectedEvent,
  vendorId,
  addBooking,
  design,
  handleSubmit,
  bookingTypes,
  bookings,
  sortedCalendars,
  loading
}) => {
  const [payoutsModalIsOpen, setPayoutsModalIsOpen] = useState(false)
  const [entityId, setEntityId] = useState(null)

  const handleBookingSubmit = data => {
    addBooking({
      booking_type_ids: data?.bookings,
      event_id: selectedEvent ? selectedEvent.id : null,
      menu_item_id: feature.id,
      vendor_id: vendorId,
    })
  }

  return (
    <React.Fragment>
      {loading ? (
        <LoadingIndicator />
      ) : (
        <Card>
          <CardBody className="shadow-sm">
            <Row className="mb-3">
              <h3>{feature.label}</h3>
            </Row>
            <Row>
              <Col>
                <Card>
                  <CardHeader>
                    <h4>SELECT BOOKING TYPE(S)</h4>
                  </CardHeader>
                  <CardBody>
                    <Row>
                      <Col xl={12}>
                        <h5>Booking Types:</h5>
                      </Col>
                      <Col xl={12}>
                        <Field
                          name="bookings"
                          component={CheckboxGroup}
                          options={sortedCalendars.map(booking => {
                            // const label =
                            //  feature?.feature === "booking_service" &&
                            //   bookings?.includes(booking?.id) ? (
                            //     <>
                            //       {booking?.calendar?.name} {">"} {booking?.name}{" "}
                            //       <span
                            //         style={{ color: "-webkit-link" }}
                            //         onClick={e => {
                            //           setPayoutsModalIsOpen(true)
                            //           setEntityId(booking.id)
                            //           e.preventDefault()
                            //         }}
                            //       >
                            //         <u>configure payouts</u>
                            //       </span>
                            //     </>
                            //   ) : (
                            //     `${booking?.calendar?.name} > ${booking?.name}`
                            //   )

                            return {
                              value: booking.id,
                              // label: label,
                              label: `${booking?.calendar?.name} > ${booking?.name}`,
                            }
                          })}
                        />
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
                <Row className="my-2">
                  <Col className="d-flex justify-content-center">
                    <SaveButton
                      content="Save"
                      type="button"
                      onClick={handleSubmit(handleBookingSubmit)}
                    />
                  </Col>
                </Row>
              </Col>
              <Col xl={4} className="mt-4 custom-features-preview">
                <Preview
                  menu_bg_color={design?.menu_bg_color}
                  menu_font_color={design?.menu_font_color}
                  booking_type={feature?.machine_name}
                  label={feature?.label}
                  bookings={bookingTypes
                    ?.filter(x => bookings?.includes(x?.id))
                    ?.slice(0, 4)}
                />
              </Col>
            </Row>
          </CardBody>
        </Card>
      )}
      <ModalComponent
        open={payoutsModalIsOpen}
        onClose={() => setPayoutsModalIsOpen(false)}
        title="Configure Payouts"
        size="lg"
      >
        <Payouts
          entity_id={entityId}
          entity_type="booking_type"
          menu_item_id={feature.id}
        />
      </ModalComponent>
    </React.Fragment>
  )
}

const selector = formValueSelector(FORM_NAMES.CREATE_BOOKING_FEATURE)

const mapStateToProps = state => ({
  selectedEvent: state.experiences.selectedEvent,
  bookingTypes: state.Bookings.bookingTypes,
  loading: state.Bookings.loading,
  vendorId: state.Login.vendorId,
  bookings: selector(state, "bookings"),
})

const mapDispatchToProps = dispatch => ({
  addBooking: values => dispatch(addBooking(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(BookingsSetup)
